import { PromotionsProvider } from '@saatva-bits/pattern-library.modules.promotions'
import { LaunchDarklyProvider } from '@saatva-bits/pattern-library.modules.launch-darkly/dist/launch-darkly.context'
import { CartProvider } from '@/store/cart'
import { CartTransformerProvider } from '@/store/cartTransformer'
import { SelectionProvider } from '@saatva-bits/pattern-library.modules.selection'
import { SharedCartServiceProvider } from '@saatva-bits/pattern-library.modules.cart'
import { RecoStripServiceProvider } from '@saatva-bits/pattern-library.modules.reco-strip'
import { ProductDetailModalProvider } from '@saatva-bits/pattern-library.components.product-detail-modal/dist/store/modal-context'
import { apiRoutes } from '@/config/globals'
import '@/styles/globals.scss'

export default function App ({ Component, pageProps }) {
    switch (pageProps.skipBaseProviders) {
    // static pages
        case true:
            return <Component {...pageProps} />
            // server side pages
        default:
            return (
                <LaunchDarklyProvider contextData={pageProps.launchDarklyContextData}>
                    <SharedCartServiceProvider apiRoute={apiRoutes.cartCheckout}>
                        <RecoStripServiceProvider apiRoutes={apiRoutes}>
                            <PromotionsProvider contextData={pageProps.promotionsContextData}>
                                <CartTransformerProvider>
                                    <CartProvider>
                                        <SelectionProvider productsData={[]}>
                                            <ProductDetailModalProvider apiRoutes={apiRoutes}>
                                                <Component {...pageProps} />
                                            </ProductDetailModalProvider>
                                        </SelectionProvider>
                                    </CartProvider>
                                </CartTransformerProvider>
                            </PromotionsProvider>
                        </RecoStripServiceProvider>
                    </SharedCartServiceProvider>
                </LaunchDarklyProvider>
            )
    }
}
